import { Divider, MenuItem, SvgIcon, Typography } from '@mui/material';
import { ChevronLeft } from '@opengov/react-capital-assets';
import React from 'react';

import { NAV_COLOR_PALETTE } from '../../Components/styleConstants';

import { DATA_TEST } from '../../enums';
import { useMobileKeyboardNavContext } from '../Context/MobileKeyboardNavContext';

interface IBackNavigationProps {
  onClick: () => void;
  title?: string;
  handleArrowDownKey?: (event: React.KeyboardEvent) => void;
}

export const BackNavigation: React.FC<IBackNavigationProps> = ({ onClick, handleArrowDownKey, title }) => {
  const { firstMobileMenuItemRef, firstMobileMenuItemIsContextSwitcher } = useMobileKeyboardNavContext();
  return (
    <>
      <MenuItem
        ref={firstMobileMenuItemIsContextSwitcher ? null : firstMobileMenuItemRef}
        autoFocus={true}
        onClick={onClick}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            // Prevent from bubbling up and triggering handleClose on PopperSubmenuContainer
            e.stopPropagation();
          }
          if (e.key === 'ArrowLeft') onClick();
          if (e.key === 'ArrowDown') handleArrowDownKey?.(e);
        }}
        data-test={DATA_TEST.mobile_back_button}
        sx={{
          color: NAV_COLOR_PALETTE.primaryGray,
          px: 4,
          position: 'relative'
        }}
      >
        <SvgIcon
          inheritViewBox
          component={ChevronLeft}
          sx={{
            position: 'absolute',
            left: '8px'
          }}
        />
        <Typography variant="bodyDefault" fontWeight="semiBold" component="span" textAlign="center" noWrap={true}>
          {title || 'Back'}
        </Typography>
      </MenuItem>
      <Divider />
    </>
  );
};
